import getStore from '../store/store';
import createEditorViewState from 'owa-editor/lib/utils/createEditorViewState';
import createRibbonViewState from 'owa-editor-ribbonplugin/lib/utils/createRibbonViewState';
import { mutatorAction } from 'satcheljs';
import DeclineMeetingSelectionState from '../store/schema/DeclineMeetingSelectionState';
export default mutatorAction('discardAutomaticRepliesOption', function discardAutomaticRepliesOption() {
    var optionState = getStore().currentState;
    var initialState = getStore().initialState;
    getStore().selectedCalendarIds = [];
    optionState.editorViewStateMessage = createEditorViewState(initialState.editorViewStateMessage.content, false);
    optionState.editorViewStateDeclineMeeting = createEditorViewState(initialState.editorViewStateDeclineMeeting.content, false);
    optionState.editorViewStateOutsideOrg = createEditorViewState(initialState.editorViewStateOutsideOrg.content, false);
    optionState.isAutomaticReplyEnabled = null;
    optionState.periodicReplyEnabled = null;
    optionState.ribbon = createRibbonViewState();
    optionState.blockCalendarEnabled = null;
    optionState.blockCalendarTitle = null;
    optionState.declineNewInvitationsEnabled = null;
    optionState.declineExistingCalendarEventsEnabled = null;
    optionState.sendRepliesToContactsOnlyEnabled = null;
    optionState.sendRepliesOutsideOrgEnabled = null;
    optionState.startDate = null;
    optionState.endDate = null;
    optionState.declineMeetingSelectedCategoryKey =
        DeclineMeetingSelectionState.UseAutomaticReplyMessage;
});
//# sourceMappingURL=discardAutomaticRepliesOption.js.map